import { postAPI } from "./Common";

const GetNotificationWithPayload = async (page, size, body) => {
  const response = await postAPI(
    "/api/Notification/GetNotificationWithPayload?pageNumber=" +
      page +
      "&pageSize=" +
      size,
    body
  );
  // console.log('post response is ',response)
  return response?.data;
};

export default GetNotificationWithPayload;
